module.exports = __webpack_public_path__ + "img/pig_ios_802.png";